// extracted by mini-css-extract-plugin
export default {"table":"ActivityTable_table__L-9WA"};